import { Skeleton, useProductViewSkeletonVariants } from '../../../../Theme'

/** Loading placeholder of a product details section: a tab bar over a content area. */
export function ContentSkeleton({ section }: { section: 'description' | 'tabContent' }) {
  const { skeletonSectionVariants, skeletonContentAreaVariants } = useProductViewSkeletonVariants()

  return (
    <div className={skeletonSectionVariants({ section })}>
      <Skeleton size="tab" width="full" />
      <div className={skeletonContentAreaVariants()}>
        <Skeleton size="fill" width="full" />
      </div>
    </div>
  )
}
